/**
 * Format game time (seconds) as mm:ss or h:mm:ss when ≥1 hour.
 * Examples: 15 → "00:15", 915 → "15:15", 4515 → "1:15:15"
 */
export function formatGameTime(seconds: number): string {
	const total = Math.floor(seconds);
	const hours = Math.floor(total / 3600);
	const mins = Math.floor((total % 3600) / 60);
	const secs = total % 60;
	const pad = (n: number) => n.toString().padStart(2, '0');
	if (hours > 0) {
		return `${hours}:${pad(mins)}:${pad(secs)}`;
	}
	return `${pad(mins)}:${pad(secs)}`;
}
